var _rect, _path, _rect2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlackMdFrameGenerator(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#191713"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.33203 19.9997C8.33203 13.5564 13.5554 8.33301 19.9987 8.33301C26.442 8.33301 31.6654 13.5564 31.6654 19.9997C31.6654 23.5795 30.0531 26.7827 27.515 28.9228C26.9954 27.4993 26.08 26.2476 24.8701 25.3192C23.4729 24.2471 21.7611 23.666 20 23.666C18.2389 23.666 16.5271 24.2471 15.1299 25.3192C13.9195 26.248 13.0039 27.5003 12.4844 28.9245C9.94519 26.7844 8.33203 23.5804 8.33203 19.9997ZM25.7956 30.1131L25.7987 30.1247C24.0903 31.1055 22.11 31.6663 19.9987 31.6663C17.8883 31.6663 15.9089 31.106 14.2009 30.126L14.2044 30.1131C14.5463 28.8373 15.2996 27.7099 16.3474 26.9059C17.3953 26.1018 18.6792 25.666 20 25.666C21.3208 25.666 22.6047 26.1018 23.6526 26.9059C24.7004 27.71 25.4537 28.8373 25.7956 30.1131ZM17.5 16.5C17.5 15.1193 18.6193 14 20 14C21.3807 14 22.5 15.1193 22.5 16.5C22.5 17.8807 21.3807 19 20 19C18.6193 19 17.5 17.8807 17.5 16.5ZM20 12C17.5147 12 15.5 14.0147 15.5 16.5C15.5 18.9853 17.5147 21 20 21C22.4853 21 24.5 18.9853 24.5 16.5C24.5 14.0147 22.4853 12 20 12Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8.83203,
    y: 8.83301,
    width: 22.3333,
    height: 22.3333,
    rx: 11.1667,
    stroke: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackMdFrameGenerator);
export default __webpack_public_path__ + "static/media/black-md-frame-generator.61f5527897e58c0e3f12389b5062dc2c.svg";
export { ForwardRef as ReactComponent };